import React from 'react';

const RoomIcon = ({
  width = '16',
  height = '16',
  fill = '#EF4821',
  ...props
}) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={width}
    height={height}
    viewBox="0 0 16 16"
    fill="none"
    {...props}
  >
    <path
      d="M10 3H13C14.1046 3 15 3.89543 15 5V11C15 12.1046 14.1046 13 13 13H10V3Z"
      fill={fill}
    />
    <path
      d="M2 4.05409C2 3.62366 2.27543 3.24152 2.68377 3.10541L6.36754 1.87749C7.66261 1.4458 9 2.40974 9 3.77485V12.2251C9 13.5903 7.66261 14.5542 6.36754 14.1225L2.68377 12.8946C2.27543 12.7585 2 12.3763 2 11.9459V4.05409Z"
      fill={fill}
    />
    <circle cx="6.5" cy="8" r="1" fill="white" />
  </svg>
);

export default RoomIcon;
